import React from 'react';

import { LayoutRoot } from './Layout';

/**
 * A basic template for a Page
 */
export const Page = React.forwardRef<
    HTMLDivElement,
    { children: React.ReactNode; className?: string }
>(function Page(props, ref) {
    const { children, className, ...rest } = props;

    return (
        <LayoutRoot ref={ref} layout="centered" className={className} {...rest}>
            {children}
        </LayoutRoot>
    );
});
